import React, { useEffect } from 'react';
import { Controller, SubmitHandler, useFieldArray, useForm } from 'react-hook-form';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
    Box,
    IconButton, TextField, Autocomplete,
} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import {
    useFieldsAddPianAtt1,
    useFieldsAddPianAtt2,
    useFieldsAddPianAtt3,
    useFieldsAddPianAtt4,
} from './FormAtt';
import {useCreatePianAtt, validationSchemaPianAtt} from './Services';
import { PianAtt } from './types';
import * as Yup from "yup";
import { FormField } from '../../common/FormField';
import dayjs from 'dayjs';
import VersOreNoteAssist, {clampVersOreNote, loadVersOreCopilotConfig} from '../gestversore/VersOreNoteAssist';

interface AddPianAtt2Props {
  open: boolean;
  onClose: () => void;
  defaultDate?: Date | null;
}

const AddPianAtt2: React.FC<AddPianAtt2Props> = ({ open, onClose, defaultDate }) => {

      type PianAttForm = Yup.InferType<typeof validationSchemaPianAtt>


const keycoddip = localStorage.getItem("keycoddip") || "";
const keyrole = localStorage.getItem("keyrole") || "";
const isAdmin =
  keyrole.includes('TimeReportAdmin') ||
  keyrole.includes('TimeReportPianAtt');

const [selectedRisorse, setSelectedRisorse] = React.useState<string[]>([]);
const [risorsaSubmitted, setRisorsaSubmitted] = React.useState(false);

  const { control, handleSubmit, reset,watch,setValue } = useForm<PianAttForm>({
    resolver: yupResolver(validationSchemaPianAtt),
     defaultValues: {
         datainiziopian: defaultDate    ? defaultDate    : new Date(),
         datafinepian: defaultDate    ? defaultDate  : new Date(),
         percomp:  0,
         minpian: 0,
         orepian: 0,
         orainiz: 9,
         mininiz: 0,
         orafine: 18,
         minfine: 0,
         ref: '',
         coddip: '', // add this
     },
  });




 // const datainiziopian = watch("datainiziopian");
 //
 // useEffect(() => {
 //
 //   console.log("datainiziopian (RHF):", datainiziopian);
 // }, [datainiziopian]);



// projects visibility per non ref tutti i progetti

 let filterProgs = '';
 if (isAdmin) {  filterProgs = 'addAdminProgs';} else {  filterProgs = 'addRefProgs';}

//console.log("canEdit:",canEdit);
//console.log("canEditPercompOnly:",canEditPercompOnly);
//console.log("filterProgs:",filterProgs);


  const selectedCodProg = watch("codprog");

  const f1 = useFieldsAddPianAtt1(true);
  const f2 = useFieldsAddPianAtt2(selectedCodProg,filterProgs,true, setValue as any);
  const f3 = useFieldsAddPianAtt3(true);
  const f4 = useFieldsAddPianAtt4(selectedCodProg,true);
  const risorsaField = f4.find(f => String(f.name) === 'coddip');
  const risorsaOptions =  typeof risorsaField?.options === 'function'  ? risorsaField.options() : risorsaField?.options ?? [];


  const { mutateAsync, isPending } = useCreatePianAtt();

const onSubmit: SubmitHandler<PianAttForm> = async data => {
  setRisorsaSubmitted(true);

  if (selectedRisorse.length === 0) {
    return;
  }

  const copilotConfig = await loadVersOreCopilotConfig();

  await Promise.all(
    selectedRisorse.map(coddip =>
      mutateAsync({
        ...data,
        coddip,
        ref: data.ref === 'NN' ? keycoddip : data.ref,
        note: clampVersOreNote(
          data.note || '',
          copilotConfig.noteMaxLength
        ).value,
      } as PianAtt)
    )
  );

  onClose();
};


useEffect(() => {
  if (!open) return;

  setSelectedRisorse([]);
  setRisorsaSubmitted(false);

  // 👉 CASE 1: no date (Nuova Att.)
  if (!defaultDate) {
    reset({
      datainiziopian: new Date(),
      datafinepian: new Date(),
      orainiz: 9,
      mininiz: 0,
      orafine: 18,
      minfine: 0,
      orepian: 0,
      minpian: 0,
      coddip: '',
    });
    return;
  }

  const d = dayjs(defaultDate);
  const isMidnight = d.hour() === 0 && d.minute() === 0;

  if (isMidnight) {
    // 👉 MONTH VIEW
    reset({
      datainiziopian: d.startOf("day").toDate(),
      datafinepian: d.startOf("day").toDate(),
      orainiz: 9,
      mininiz: 0,
      orafine: 18,
      minfine: 0,
      orepian: 0,
      minpian: 0,
      percomp: 0,
      coddip: '', // add this
    });
  } else {
    // 👉 WEEK VIEW
    const end = d.add(1, "hour");

    reset({
      datainiziopian: d.toDate(),
      datafinepian: d.toDate(),
      orainiz: d.hour(),
      mininiz: d.minute(),
      orafine: end.hour(),
      minfine: end.minute(),
      orepian: 0,
      minpian: 0,
      percomp: 0,
      coddip: '',

    });
  }
}, [open, defaultDate, reset]);



  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        <Typography variant="h6">Nuova Attività</Typography>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2}>{f1.map(f => <FormField key={String(f.name)} control={control} field={f} />)}</Stack>
            <Stack direction="row" spacing={2}>
                {f2.map(f => <FormField key={String(f.name)} control={control} field={f} />)}
                {f3.map(f => <FormField key={String(f.name)} control={control} field={f} />)}
            </Stack>
            {/*<Stack direction="row" spacing={2}>{f4.map(f => <FormField key={String(f.name)} control={control} field={f} />)}</Stack>*/}

              <Stack direction="row" spacing={2}>
  {risorsaField && (
    <Autocomplete
      multiple
      disablePortal
      sx={{ width: risorsaField.boxSize ?? '50%' }}
      disabled={risorsaField.disabled}
      options={risorsaOptions}
      value={risorsaOptions.filter((opt: any) =>
        selectedRisorse.includes(opt[risorsaField.optionValueKey ?? 'value'])
      )}
      getOptionLabel={(option: any) =>
        option?.[risorsaField.optionLabelKey ?? 'label'] ?? ''
      }
      isOptionEqualToValue={(option: any, value: any) =>
        option?.[risorsaField.optionValueKey ?? 'value'] ===
        value?.[risorsaField.optionValueKey ?? 'value']
      }
      onChange={(_, newValue) => {
              const values = newValue.map((item: any) =>
                item[risorsaField.optionValueKey ?? 'value']
              );

              setSelectedRisorse(values);
              if (values.length > 0) {    setRisorsaSubmitted(false);  }

              setValue("coddip", values[0] ?? "", {
                shouldValidate: true,
                shouldDirty: true,
              });
       }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Risorse*"
          margin="dense"
          fullWidth
          error={risorsaSubmitted && selectedRisorse.length === 0}
          helperText={risorsaSubmitted && selectedRisorse.length === 0  ? 'Seleziona almeno una risorsa'    : ''}
        />
      )}
    />
  )}
</Stack>


              <Controller
              name="note"
              control={control}
              render={({ field, fieldState }) => (
                <VersOreNoteAssist
                  textFieldId="pian-att-add-note"
                  value={String(field.value || '')}
                  onChange={field.onChange}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  rows={3}
                />
              )}
            />
            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button onClick={onClose} color="error">Annulla</Button>
              <Button type="submit" variant="contained" disabled={isPending}>
                {isPending ? 'Salvando…' : 'Salva'}
              </Button>
            </Stack>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddPianAtt2;
